import EditorJS from '@editorjs/editorjs'
import Header from '@editorjs/header'
import EditorjsList from '@editorjs/list'
import Table from '@editorjs/table'
import Quote from '@editorjs/quote'
import Delimiter from '@editorjs/delimiter'
import Paragraph from '@editorjs/paragraph'
import ImageTool from '@editorjs/image';
import RawTool from '@editorjs/raw';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      editorjs: {
        EditorJS,
        tools: {
          paragraph: Paragraph,
          header: {
            class: Header,
            config: {
              placeholder: 'Enter a header',
              levels: [2, 3, 4],
              defaultLevel: 3
            }
          },
          list: EditorjsList,
          table: Table,
          quote: Quote,
          delimiter: Delimiter,
          image: ImageTool,
          raw: RawTool
        }
      }
    }
  }
})